import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddCifa2 = ({styles, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Ciclo de facturación nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="cicloFact" id="cicloFact" onChange={handleChange} placeholder='Ciclo' icon={!errors.length?null: _find(errors, {path:'cicloFact'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <div className="ui one column stackable grid">
                    <div className="column" style={{width: '100%'}}>
                      <input type='checkbox' name="noFactRET" style={styles.input} onChange={handleChange}/>
                      <label style={styles.label}>&nbsp;NO FACTURAR clientes en estado RETIRADO y con saldo menor o igual a cero</label>
                    </div>
                  </div>
                </Form.Field>
                <hr></hr>

                <Button type='submit' primary fluid>
                  Agregar
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddCifa2
